import { Typography, Card, Box, useMediaQuery, Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TextField, ReferenceField, useRecordContext } from "react-admin";
import Label, { statusText } from '../../../components/Label';
import { StatusLabel } from '../../../components/Label/status';
import AnimatedBlock from '../../../components/Common/AnimatedBlock';
import InfoRow from '../../../components/Common/InfoRow';
import { listPermissions } from '../create';

// Coinhouse internal roles (64 and above) read as primary, client roles as neutral.
export const PermissionLabel = () => {
  const { t }: { t: any } = useTranslation();
  const user = useRecordContext();
  const permission = listPermissions().find((permission) => permission.id === user?.permissionLevel);
  if (!permission) return null;
  return (
    <Label color={permission.id >= 64 ? 'primary' : 'secondary'}>
      {t(statusText(permission.name))}
    </Label>
  );
};

function InfoUserTab() {
  const { t }: { t: any } = useTranslation();
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('sm'));
  const user = useRecordContext();
  if (!user) return null;

  return (
    <Box>
      {!isMobile && (
        <Box pb={2}>
          <Typography variant="h6">{t('User details')}</Typography>
          <Typography variant="body2" color="text.secondary">
            {t('Identity of the user, the account they belong to and their access.')}
          </Typography>
        </Box>
      )}
      <AnimatedBlock>
        <Card>
          <Box px={2} py={1}>
            <InfoRow label={t('Name')}>{user.name}</InfoRow>
            <InfoRow label={t('Email')}>{user.email}</InfoRow>
            <InfoRow label={t('Account')}>
              <ReferenceField source="accountId" reference="accounts" link="show">
                <TextField source="name" sx={{ fontWeight: 700 }} />
              </ReferenceField>
            </InfoRow>
            <InfoRow label={t('Role')}>
              <PermissionLabel />
            </InfoRow>
            <InfoRow label={t('Status')}>
              <StatusLabel fontSize="small" statusField="status" />
            </InfoRow>
            <InfoRow label={t('ID')}>
              <Typography component="span" sx={{ fontFamily: 'monospace', fontSize: 13, fontWeight: 400 }}>
                {user.id}
              </Typography>
            </InfoRow>
          </Box>
        </Card>
      </AnimatedBlock>
    </Box>
  );
}

export default InfoUserTab;
